import { mockSuccess } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

let CAMPAIGN_SETTINGS = {
    default_platform: 'sentiment-analysis',
    export_webhook_url: 'https://example.com/hooks/campaigns',
    retention_days: 90,
    auto_archive_inactive: true,
};

const CAMPAIGNS = [
    {
        id: 101,
        name: 'Brand sentiment Q2',
        description: 'Monitor brand mentions across networks',
        type: 'sentiment-analysis',
        status: 'ACTIVE',
        date: '2026-06-01',
        statistics: { count: 240 },
        sentiments: { count: 240, positive: 120, neutral: 80, negative: 40 },
    },
    {
        id: 102,
        name: 'Facebook ads scrape',
        description: 'Competitor ad library harvest',
        type: 'facebook-ads-scrapper',
        status: 'ACTIVE',
        date: '2026-05-15',
        statistics: { count: 88 },
    },
    {
        id: 103,
        name: 'TikTok hashtag watch',
        description: 'Track #ashcorp and related tags',
        type: 'tiktok-hashtag-scrapper',
        status: 'INACTIVE',
        date: '2026-04-20',
        statistics: { count: 512 },
    },
];

function paged<T>(items: T[]) {
    return { items, count: items.length, page: 1, size: items.length };
}

export const CAMPAIGN_MOCK_HANDLERS: MockRouteEntry[] = [
    { method: 'GET', pattern: /\/api\/campaign\/settings/i, handler: () => mockSuccess(CAMPAIGN_SETTINGS) },
    {
        method: 'PATCH',
        pattern: /\/api\/campaign\/settings/i,
        handler: (req) => {
            CAMPAIGN_SETTINGS = { ...CAMPAIGN_SETTINGS, ...(req.body as object) };
            return mockSuccess(CAMPAIGN_SETTINGS);
        },
    },

    {
        method: 'POST',
        pattern: /\/api\/campaign\/list/i,
        handler: () => mockSuccess(paged(CAMPAIGNS)),
    },
    {
        method: 'POST',
        pattern: /\/api\/campaign\/stats/i,
        handler: () =>
            mockSuccess({
                totals: { all: CAMPAIGNS.length, active: 2, inactive: 1, pending: 0 },
                campaigns: CAMPAIGNS,
                items: CAMPAIGNS,
                count: CAMPAIGNS.length,
                ...paged(CAMPAIGNS),
            }),
    },
    {
        method: 'POST',
        pattern: /\/api\/campaign\/single/i,
        handler: (req) => {
            const id = Number((req.body as { id?: number })?.id);
            const row = CAMPAIGNS.find((c) => c.id === id) ?? CAMPAIGNS[0];
            return mockSuccess(row);
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/campaign\/create/i,
        handler: (req) => {
            const body = (req.body || {}) as Record<string, unknown>;
            const next = {
                id: 200 + CAMPAIGNS.length,
                name: String(body['name'] || 'New campaign'),
                description: String(body['description'] || ''),
                type: String(body['type'] || 'sentiment-analysis'),
                status: 'PENDING' as const,
                date: '2026-06-04',
                statistics: { count: 0 },
            };
            CAMPAIGNS.push(next);
            return mockSuccess(next);
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/campaign\/update/i,
        handler: (req) => {
            const body = (req.body || {}) as Record<string, unknown>;
            const id = Number(body['id']);
            const idx = CAMPAIGNS.findIndex((c) => c.id === id);
            if (idx >= 0) {
                CAMPAIGNS[idx] = { ...CAMPAIGNS[idx], ...body, id };
                return mockSuccess(CAMPAIGNS[idx]);
            }
            return mockSuccess(CAMPAIGNS[0]);
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/campaign\/status/i,
        handler: () => mockSuccess(null),
    },
    {
        method: 'POST',
        pattern: /\/api\/campaign\/content\/list/i,
        handler: () =>
            mockSuccess(
                paged([
                    {
                        id: 1,
                        text: 'Sample scraped post (mock)',
                        url: 'https://example.com/post/1',
                        date: '2026-06-04',
                        data: {},
                    },
                ])
            ),
    },
    {
        method: 'POST',
        pattern: /\/api\/campaign\/content\/single/i,
        handler: (req) => {
            const id = Number((req.body as { id?: number })?.id);
            return mockSuccess({
                id,
                overview: { id, platform: 'mock' },
                campaign: { id: 101, name: 'Brand sentiment Q2' },
                data: { note: 'UI-only content detail placeholder' },
            });
        },
    },
];
